import { logger } from '@tuic/logger';

export const getNodeText = (node: React.ReactNode): string => {
  if (node == null) return '';

  switch (typeof node) {
    case 'string':
    case 'number':
      return node.toString();

    case 'boolean':
      return '';

    case 'object': {
      if (node instanceof Array) return node.map(getNodeText).join('');

      if ('props' in node) return getNodeText((node.props as any).children);
    } // eslint-ignore-line no-fallthrough

    default:
      logger.warn('Unresolved `node` of type:', typeof node, node);
      return '';
  }
};
